// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notify_notification__KUwoW","notifTitle":"Notify_notifTitle__34-pr","timeAgo":"Notify_timeAgo__EGxjr","read":"Notify_read__1BaZw"};